import { Component, Inject, Input, OnInit } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { MessageService } from 'primeng/api';

import { attributeTypesEnum } from '../../../Misc/enums/attribute-types.enum';
import { MediaTypeEnum } from '../../../Basic/enums/media-type.enum';
import { ButtonTypesEnum } from '../../enums/button-types.enum';
import { SearchCriteriaQuerySentimentsEnum } from '../../../../api/mentions/enum/search-criteria-query-sentiments.enum';
import { copy } from '../../../Misc/helpers/copy/copy.helper';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';

@Component({
    selector: 'agpr-meta-data',
    templateUrl: './meta-data.component.html',
    styleUrls: ['./meta-data.component.scss'],
    standalone: false
})
export class MetaDataComponent implements OnInit {

    @Input() id: string;
    @Input() type: attributeTypesEnum;
    @Input() mediaType: MediaTypeEnum;
    @Input() icon: string;
    @Input() value: string | number;
    @Input() tooltip: string;
    @Input() tooltipPosition: string = 'top';
    @Input() ariaLabel: string;
    @Input() infoTooltip: string;
    @Input() isSimilarWeb: boolean = false;
    @Input() isMultiline: boolean = false;
    @Input() initiallyFocusable: boolean = true;
    @Input() showCopyIcon: boolean = false;
    @Input() copyValue?: string;
    @Input() copyToolTip?: string;

    readonly attributeTypes = attributeTypesEnum;
    readonly sentimentTypes = SearchCriteriaQuerySentimentsEnum;
    readonly buttonTypes = ButtonTypesEnum;
    readonly similarwebTooltip = this.localizationService.transform(
        'Common.audienceReach.similarweb.tooltip.insightsBy',
        {src: this.appBaseHref + 'assets/images/SimilarWeb-logo-with-text.svg'}
    );

    composedId: string = '';

    constructor(
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        private messageService: MessageService,
        private localizationService: LocalizationService
    ) {}


    ngOnInit(): void {
        // compute new id, remove whitespace
        this.composedId = [this.id, attributeTypesEnum[this.type], this.value]
            .filter(Boolean)
            .join('_')
            .replace(/\s+/g, '');
    }

    copy(event: Event, value: string | number): void {
        if (!value) {
            return;
        }
        copy.text(value);
        this.messageService.add({
            severity: messageSeverityEnum.success,
            summary: this.localizationService.transform('Common.meta.copied.summary', {
                name: this.copyToolTip ||  this.tooltip
            }),
            detail: this.localizationService.transform('Common.meta.copied.detail', {
                name: this.copyToolTip ||  this.tooltip
            }),
        });
        (event.target as HTMLElement)?.focus();
    }
}
